// import '../core/lockdown'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'wouter'

import { Auth } from './useAuth'

import { Home } from './Home'
import { Chat } from './Chat'

function Web() {
  return (
    <Auth>
      <Router>
        <Switch>
          <Route path='/' component={Home} />
          <Route path='/:simId' component={Chat} />
        </Switch>
      </Router>
    </Auth>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<Web />)
